import { html, css, LitElement } from 'lit'; 
import { Image } from '../Image/Image'; 
import '../MediaGallery/MediaGallery';
import videoPlaceholder from '../../../assets/images/videoPlaceholder.svg';
import imagePlaceholder from '../../../assets/images/imagePlaceholder.svg';
import AudioPlaceholder from '../../../assets/images/equalizer.svg';

class MediaList extends LitElement {
  static properties = {
    mediaArray: { type: Array },
    padding: { type: String },
    bgColor: { type: String },
    borderRadius: { type: String },
    border: { type: String },
    color: { type: String },
    height: { type: String }, 
    width: { type: String },
    showGallery: { type: Boolean },
    selectedIndex: { type: Number },
  };
  
  constructor() {
    super();
    this.showGallery = false;
    this.selectedIndex = 0;
  }
  
  static styles = css`
    :host {
      display: block;
      width: 100%;
    }
    
    .media-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      width: 100%;
      box-sizing: border-box;
    }
    
    .media-list-body {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      width: 100%;
    }
    
    .media-item {
      aspect-ratio: 1/1;
      width: 100%;
      min-width: 80px;
    }
    
    .media-list-body img {
      cursor: pointer;
      transition: transform 0.2s ease;
      width: 100%;
      height: 100%;
    }
    
    .media-list-body img:hover {
      transform: scale(1.05);
    }
    
    .media-gallery-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100dvh;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 1000;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .media-gallery-container media-gallery {
      width: 100%;
      height: 100%;
    }
    
  `;
  
  _handleClose() {
    this.dispatchEvent(new CustomEvent('media-list-close'));
  }
  
  _handleMediaClick(index) {
    this.selectedIndex = index;
    this.showGallery = true;
  }
  
  _handleGalleryClose() {
    this.showGallery = false;
  }
  
  render() {
    const formattedAttachments = this.mediaArray.map(mediaUrl => ({
      attachments: [{
        mediaUrl: mediaUrl,
        mimeType: mediaUrl.match(/\.(jpg|jpeg|png|gif)$/i) ? 'image/jpeg' : 
          mediaUrl.match(/\.(mp4|mov|avi)$/i) ? 'video/mp4' :
          mediaUrl.match(/\.(mp3|wav|webm|ogg|m4a|aac)$/i) ? 'audio/mpeg' :
          'application/octet-stream'
      }]
    }));
    return html`
      ${this.showGallery ? 
        html`
        <div class="media-gallery-container">
          <media-gallery
            .allAttachments="${formattedAttachments}"
            .mainImageIndex=${this.selectedIndex}
            .images="${this.mediaArray}"
            @close=${this._handleGalleryClose}
          ></media-gallery>
        </div>` 
        : 
        html`<div
          class="media-list"
          style="height: ${this.height}; width: ${this.width}; padding: ${this.padding}; background-color: ${this.bgColor}; border-radius: ${this.borderRadius}; border: ${this.border}; color: ${this.color}; overflow: auto;"
        >
          <div class="media-list-body">
            ${this.mediaArray.map(
              (media, index) =>
                html`<div class="media-item" @click=${() => this._handleMediaClick(index)}>
                  ${Image({
                    src: media,
                    alt: 'Media',
                    height: '100%',
                    width: '100%',
                    objectFit: 'cover',
                    backgroundColor: 'var(--base-color)',
                    borderRadius: "15px",
                    placeholderImage: media.match(/\.(jpg|jpeg|png|gif)$/i) === 0 ? imagePlaceholder : media.match(/\.(mp4|mov|avi)$/i) ? videoPlaceholder : AudioPlaceholder
                  })}
                </div>`,
            )}
          </div>
        </div>`
      }`;
  }
}

customElements.define('media-list', MediaList);